<span (click)="clickCheckbox()">
    <mat-icon *ngIf="!checked" class="clickable not-checked" [ngClass]="{'disabled': input.element.disabled}">check_box_outline_blank</mat-icon>
    <mat-icon *ngIf="checked" class="clickable checked">check_box</mat-icon>
</span>